module.exports = __webpack_public_path__ + "img/4.567c7861.jpg";